export default (node) => {
	const openers = document.querySelectorAll(`[aria-controls="${node.id}"]`);
	openers.forEach((opener) => {
		opener.addEventListener('click', () => {

			if (
				opener.classList.contains('close-menu')
				&& document.querySelector('#dialog-expertises').classList.contains('active')
				&& document.querySelector('#dialog-menu').classList.contains('active')
			) {
				toggle(document.querySelector('#dialog-menu'))	
			}

			toggle(node)
		});

		opener.classList.add('dialog-init');
	});

	const box = node.querySelector('.box');

	if (box) {
		node.addEventListener('click', (e) => {
			if (box !== e.target && !box.contains(e.target) && !Array.from(openers).includes(e.target)) {
				toggle(node);
			}
		})
	}
};

export function toggle(node) {
	var active = !node.classList.contains('active');
	var delay = (active) ? 0 : 0;

	node.classList.toggle('active');

	setTimeout(() => {
		node.classList.toggle('is-inview');
	}, delay);

	if (active) {
		window.locomotive.stop();
		return;
	}

	window.locomotive.start();
}